import { useCallback, useEffect, useRef } from 'react';

import { useChat } from '../../../hooks/useChat';

// TODO: link this to chat input to get the right height
const chatInputHeightEstimation = 100;

export const useChatMessages = () => {
  const chatListRef = useRef(null);
  const { history } = useChat();

  const scrollToBottom = useCallback(() => {
    if (chatListRef.current) {
      chatListRef.current.scrollTo?.({
        top: chatListRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    const computeCardHeight = () => {
      if (chatListRef.current) {
        const cardTop = chatListRef.current.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        const cardHeight = windowHeight - cardTop - chatInputHeightEstimation;
        chatListRef.current.style.height = `${cardHeight}px`;
      }
    };

    computeCardHeight();
    window.addEventListener('resize', computeCardHeight);

    return () => {
      window.removeEventListener('resize', computeCardHeight);
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [history, scrollToBottom]);

  return {
    chatListRef,
  };
};

export default useChatMessages;
